import { render } from "./MainCategoryItem.vue?vue&type=template&id=434a130a&scoped=true"
import script from "./MainCategoryItem.vue?vue&type=script&lang=js"
export * from "./MainCategoryItem.vue?vue&type=script&lang=js"

import "./MainCategoryItem.vue?vue&type=style&index=0&id=434a130a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-434a130a"]])

export default __exports__